import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=509f2b92&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=509f2b92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509f2b92",
  null
  
)

export default component.exports